import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/vant.js'
import './style/components.css'
import pageView from './layouts/pageView'

// import VConsole from 'vconsole'

Vue.config.productionTip = false
Vue.component('page-view', pageView)
// const log = new VConsole()
// Vue.use(log)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
